import React from "react";
import { useParams } from "react-router-dom";
import { EvtHeader } from "components/header";
import DeliverableForm from "@/modules/work/projects/deliverables/crud/form";
import { useProject } from "@/modules/work/projects/context";

const UpdateDeliverable = () => {
  const { deliverableId } = useParams();
  const { id: projectId } = useProject();
  if (!projectId) return null;
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Deliverable" />
      <div className="p-6 max-w-2xl">
        <DeliverableForm projectId={projectId} deliverableId={deliverableId} />
      </div>
    </div>
  );
};

export default UpdateDeliverable;
